<template>
    <div class='t_content_view'>
        <el-page-header @back="goBack" content="新增/编辑欢迎语" style="margin-bottom: 20px;" />
        <!-- 标题 -->
        <div class="t_title_box_f">
            <div class="t_blue_line"></div>
            <div>基础信息</div>
        </div>
        <div class="t_con_box_f">
            <div class="t_con_title_f"><span style="color: #F20000;">*</span>欢迎语标题：</div>
            <div>
                <el-input v-model="sendtitle" maxlength="20" style="width: 600px;"  placeholder="请输入欢迎语标题，最多20个字"  clearable />
            </div>
        </div>
        <div class="t_con_box_f">
            <div class="t_con_title_f"><span style="color: #F20000;">*</span>选择使用成员：</div>
            <div>
                <!-- <el-select  multiple v-model="userIds.data" placeholder="请选择成员">
                    <el-option style="height: auto;line-height: normal;padding:8px 32px 8px 20px" v-for="(item,index) in allpeolist.data" 
                    :key="index"
                    :value="item.id" :label="item.name" >
                    </el-option>
                </el-select> -->
                <el-cascader
                    v-model="selectedPath.data"
                    :options="allcomppeolist.data"
                    :props="{ expandTrigger: 'hover',multiple: true }"
                    placeholder="请选择成员"
                    clearable
                    @change="handleChange"
                    />
                <div style="font-size: 13px;color: #777777;margin-top: 10px;">
                    1.多个成员可设置同一欢迎语；同一成员重复设置欢迎语，只使用最新设置的欢迎语
                </div>
                <div style="font-size: 13px;color: #777777;margin-top: 5px;">
                    2.在渠道活码处设置的欢迎语会被优先推送，如果成员在渠道活码处设置了欢迎语，在此设置的欢迎语不会生效
                </div>
            </div>
        </div>
        <!-- line -->
        <div class="t_line"></div>
        <!-- 标题 -->
        <div class="t_title_box_f">
            <div class="t_blue_line"></div>
            <div>欢迎语</div>
        </div>
        <div class="t_con_box_f">
            <div class="t_con_title_f"><span style="color: #F20000;">*</span>欢迎语文案：</div>
            <div>
                <div style="border: 1px solid #dcdfe6;border-radius: 5px;padding-bottom: 10px;width: 600px;">
                    <el-input @blur="testBlur" class="t_textarea_nobod" v-model="sendcon"  type="textarea" rows="7"   placeholder="请输入欢迎语文案"  clearable />
                    <el-button @click="addname" style="margin-top: 10px;margin-left: 10px;">插入用户昵称</el-button>
                </div>
            </div>
        </div>
        <div class="t_con_box_f">
            <div class="t_con_title_f">添加内容：</div>
            <div style="position:relative;">
                <el-checkbox @change="contypebtn(1)" v-model="checked1" label="网页" border />
                <el-checkbox @change="contypebtn(2)" v-model="checked2" label="图片" border />
                <div v-if="checked1" >
                    <div class="t_con_box_f" style="align-items:center;margin-top: 20px;">
                        <div class="t_con_title_f" style="width: 120px;">* 链接：</div>
                        <div>
                            <el-input
                                v-model="weblink" 
                                @input="weblinkchange" 
                                style="width: 400px;"  placeholder="请输入链接"  clearable />
                        </div>
                    </div>
                    <div class="t_con_box_f" style="align-items:center;margin-top: 20px;">
                        <div class="t_con_title_f" style="width: 120px;">* 网页标题：</div>
                        <div class="t_web_con">
                            <el-input 
                            @input="webconchange"
                            @focus="focusinput(2)"
                            v-model="webcon_emojisOutput" class="t_speak_input"  placeholder=""  rows="5" type="textarea"  clearable />
                            <img src="../assets/img/emoji.png" class="t_emoji_img" @click="showemoji" alt="">
                        </div>
                    </div>
                    <div class="t_con_box_f" style="align-items:center;margin-top: 20px;">
                        <div class="t_con_title_f" style="width: 120px;">* 网页描述：</div>
                        <div class="t_web_con">
                            <el-input 
                            @focus="focusinput(3)"
                            @input="webdeschange"
                            v-model="webdes_emojisOutput" class="t_speak_input"  placeholder=""  rows="5" type="textarea"  clearable />
                            <img src="../assets/img/emoji.png" class="t_emoji_img" @click="showemoji" alt="">
                        </div>
                    </div>
                    <div class="t_con_box_f" style="align-items:center;margin-top: 20px;">
                        <div class="t_con_title_f" style="width: 120px;">* 网页图标：</div>
                        <div>   
                            <el-upload
                            :headers="headers"
                            class="avatar-uploader"
                            :action="upload_img"
                            :data="upData"
                            accept="image/jpg,image/jpeg,image/png"
                            :show-file-list="false"
                            :on-success="web_handleAvatarSuccess"
                            :before-upload="web_beforeAvatarUpload">
                            <img v-if="web_imgurl" :src="web_imgurl" class="avatar" />
                                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
                            </el-upload>
                            <div style="width: 400px;font-size: 13px;color: #777777;margin-top: 10px;">
                                建议图片比例1:1，图片大小不能超过2MB，分辨率不能超过1080*1080，支持jpg、jpeg、png格式
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div v-if="checked2">
                    <el-upload
                        drag
                        ref="upload"
                        :action="upload_img"
                        :data="upData"
                        accept="image/jpg,image/jpeg,image/png"
                        :on-success="img_handleAvatarSuccess"
                        :before-upload="beforeimageUpload"
                        :show-file-list="false"
                        style="margin-top:15px;margin-bottom:15px;width: 500px;"
                        :headers="headers"
                        multiple>
                        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                        <div class="el-upload__text">
                            拖拽或点击上传图片
                        </div>
                    </el-upload>
                    <img v-if="img_imgurl" :src="img_imgurl" class="avatar2" />
                </div>
                <Picker style="position: absolute;top: 0;left: 620px;" v-if='isshowemoji' :data="emojiIndex" set="twitter" @select="selectEmoji" />
            </div>
        </div>
        <div class="t_con_box_f">
            <el-button  color="#4F46E5" @click="submit" style="margin-left:150px" type="primary">新增欢迎语</el-button>
            <el-button   @click="goBack" style="margin-left:150px" >取消</el-button>
        </div>
    </div>
</template>

<script setup>
import data from "emoji-mart-vue-fast/data/all.json";
// Import default CSS
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast/src";


import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Tickets,Picture } from '@element-plus/icons-vue'
import { ElMessage,ElMessageBox } from 'element-plus'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { AddWelcome,checkWelcome,EditWelcome,newgetpeo,newaddwelcome ,newwelcomedetail,newgetcomppeo} from '@/assets/js/common.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')
const goBack = () => {
    router.push({ path: '/navtkyl/friendwelcome' })
}
//判断是否是编辑
const is_edit = ref(false)
const headers = {
  'Authorization': 'Bearer ' + $cookies.get("fanstoken")
}
onMounted(() => {
    console.log('onMounted')
    getallpeolist()
    if(route.query.id){
        //是编辑
        is_edit.value = true
        checklist()
    }else{
        //是新增
        is_edit.value = false
    }
    //获取主体+成员
    getcomppeolist()
})
//群发标题
const sendtitle = ref('')
//选择成员
const userIds = reactive({
  data:[]
})
//所有成员下拉数组
const allpeolist = reactive({
    data:[]
})
//获取所有成员下拉
const getallpeolist = ()=>{
    newgetpeo().then((response)=>{
        if (response.data.msg.code == 0) {
             console.log('成员==')
             console.log(response.data)
            allpeolist.data = response.data.data
        }
    })
}
//群发文案
const sendcon = ref('')
//储存焦点位置
const Blurindex = ref(0)
//获取焦点位置
const testBlur = (e)=>{
    console.log('获取焦点')
    console.log(e.srcElement.selectionStart)
    Blurindex.value = e.srcElement.selectionStart
}
//插入成员名
const addname = ()=>{
    // form.data.desc = form.data.desc+'${name}'

    var yuantest = sendcon.value
    sendcon.value = yuantest.slice(0,Blurindex.value)+'${name}'+yuantest.slice(Blurindex.value)

    
}
//选择内容种类
const checked1 = ref(false)
const checked2 = ref(false)
const contypebtn = (type)=>{
    if(type==1){
        if(checked1.value==true){
            checked1.value=true
            checked2.value=false
        }
    }else if(type==2){
        if(checked2.value==true){
            checked1.value=false
            checked2.value=true
        }
    }
    //清除临时储存待发送内容
    rest_ready()
}

//临时储存待发送内容 
const temporary = reactive({
    data:{
        ContentType:'',//种类
        Content:'',//内容
        desc:'',//描述
        thumbUrl:'',//图片地址或网站地址
        jContent:{
            desc:'',
            thumbUrl:'',
            title:'',
            url:'',
        },//网页内容

    }
})

//清除临时储存待发送内容
const rest_ready = ()=>{
    temporary.data.ContentType = ''
    temporary.data.Content = ''
    temporary.data.desc = ''
    temporary.data.thumbUrl = ''
    temporary.data.jContent = {
        desc:'',
        thumbUrl:'',
        title:'',
        url:'',
    }
    //网页
    weblink.value = ''
    webcon_emojisOutput.value = ''
    webdes_emojisOutput.value = ''
    web_imgurl.value = ''
    //图片
    img_imgurl.value = ''
}

//表情数据
const emojiIndex = new EmojiIndex(data)
//是否显示emoji选择框
const isshowemoji = ref(false)
//打开emoji选择框
const showemoji = ()=>{
  isshowemoji.value=!isshowemoji.value
}


//设置文本类型或网页类型，三个输入框到底选中了哪个输入框
const whichinput = ref(0)
//获得焦点，选中输入框
const focusinput = (i)=>{
    whichinput.value = i
}

//监听选表情
const selectEmoji = (emoji)=> {
    //根据焦点确认往那个输入框中输入表情
    if(whichinput.value==1){
        //文本类型的输入框
        emojisOutput.value = emojisOutput.value + emoji.native;
        //内容添加到临时编辑内容中
        temporary.data.Content = emojisOutput.value
    }else if(whichinput.value==2){
        //网页标题
        webcon_emojisOutput.value = webcon_emojisOutput.value + emoji.native;
        //内容添加到临时编辑内容中
        temporary.data.jContent.title = webcon_emojisOutput.value
    }else if(whichinput.value==3){
        //网页描述
        webdes_emojisOutput.value = webdes_emojisOutput.value + emoji.native;
        //内容添加到临时编辑内容中
        temporary.data.desc = webdes_emojisOutput.value
        temporary.data.jContent.desc = webdes_emojisOutput.value
    }
  
}

//网页===

//网页链接
const weblink = ref('')
const weblinkchange = ()=>{
    //内容添加到临时编辑内容中
    temporary.data.jContent.url = weblink.value
}

//网页标题
const webcon_emojisOutput = ref('')
const webconchange = ()=>{
    //内容添加到临时编辑内容中
    temporary.data.jContent.title = webcon_emojisOutput.value
}

//网页描述
const webdes_emojisOutput = ref('')
const webdeschange = ()=>{
    //内容添加到临时编辑内容中
    temporary.data.desc = webdes_emojisOutput.value
    temporary.data.jContent.desc = webdes_emojisOutput.value
}


//上传图片地址
const upload_img = '/api/upload/file'
// const headers = reactive({
//   'token': $cookies.get("fanstoken")
// })
const upData=reactive(
  { file: '', file_type: '' }
)  // 上传文件data
//网页缩略图
//回显地址
const web_imgurl = ref('')
//上传返回参数
// const web_imgurl_result = ref('')

//上传成功
const web_handleAvatarSuccess = (response,uploadFile)=>{
    
   
    web_imgurl.value = response.data.url
    // web_imgurl_result.value = response.result
    //存入临时储存待发送内容
    temporary.data.thumbUrl = web_imgurl.value 
    temporary.data.jContent.thumbUrl = web_imgurl.value 
    console.log('上传成功')
    console.log(response)
    console.log(web_imgurl.value)
}
//上传前检测
const web_beforeAvatarUpload = (rawFile)=>{
    upData.file = rawFile
    upData.file_type = 'image'

    if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('上传图片大小不能超过2MB!')
        return false
    }
    return true
}

//图片===
//回显地址
const img_imgurl = ref('')
//上传前检测
const beforeimageUpload = (rawFile)=>{
    upData.file = rawFile
    upData.file_type = 'image'

    if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('上传图片大小不能超过2MB!')
        return false
    }
    return true
}
//拖拽点击上传成功
const img_handleAvatarSuccess = (response,uploadFile)=>{
    
   console.log(response)
    img_imgurl.value = response.data.url
    // img_imgurl_result.value = response.result

    //存入临时储存待发送内容
    temporary.data.thumbUrl = img_imgurl.value 
    temporary.data.Content = img_imgurl.value 
    console.log('上传成功')
    console.log(response)
    // console.log(response.result.url)
}

//提交
const submit = ()=>{
    if(checked1.value==true&&checked2.value==false){
        //网页
        temporary.data.ContentType = 'Link'
        temporary.data.Content = JSON.stringify(temporary.data.jContent)

        var typenum = '1'

    }else if(checked2.value==true&&checked1.value==false){
        //图片
        temporary.data.ContentType = 'Picture'

        var typenum = '2'
    }else{
        temporary.data.ContentType = ''

        var typenum = '0'
    }
    console.log(temporary.data)

    //提交数据
    if(sendtitle.value==''){
        ElMessage.error('请输入标题')
        return
    }else if(selectedPath.data.length==0){
        ElMessage.error('请选择成员')
        return
    }else if(sendcon.value==''){
        ElMessage.error('请输入内容')
        return
    }

    //发送文字消息
    // var temporarytext = {
    //     ContentType:'Text',//种类
    //     Content:sendcon.value,//内容
    //     desc:'',//描述
    //     thumbUrl:'',//图片地址或网站地址
    //     jContent:{
    //         desc:'',
    //         thumbUrl:'',
    //         title:'',
    //         url:'',
    //     },//网页内容
    // }

    //合并发送消息
    // var sendcontent = []
    // if(temporary.data.ContentType==''){
    //     //没有网页或图片
    //     sendcontent.push(temporarytext)
    // }else{
    //     //有网页或图片
    //     sendcontent.push(temporarytext)
    //     sendcontent.push(temporary.data)
    // }
    var corp_members = []
    //讲二维数组[[1,2],[3,4]]转为一维数组[{"corp_id"=>1,"id"=>2},{"corp_id"=>3,"id"=>4}]格式
    corp_members = selectedPath.data.map(item => ({
        corp_id: item[0],
        id: item[1]
    }))
   
    //判断编辑还是新增
    if(is_edit.value){
        //编辑
         var datainfo = {
            id:route.query.id,
            title:sendtitle.value,
            user_id:corp_members,
            content:sendcon.value,
            type:typenum,
            image:temporary.data.thumbUrl,
            web_url:temporary.data.jContent.url,
            web_title:temporary.data.jContent.title,
            web_des:temporary.data.desc,
            web_image:temporary.data.thumbUrl,
        }
        console.log(datainfo)
        
        newaddwelcome(datainfo).then((response)=>{
            console.log(response)
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功！',
                })
                router.push({ path: '/navtkyl/friendwelcome' })
            }
        })
    }else{
        //新增
        var datainfo = {
            title:sendtitle.value,
            user_id:corp_members,
            content:sendcon.value,
            type:typenum,
            image:temporary.data.thumbUrl,
            web_url:temporary.data.jContent.url,
            web_title:temporary.data.jContent.title,
            web_des:temporary.data.desc,
            web_image:temporary.data.thumbUrl,


            
        }
        console.log(datainfo)
        newaddwelcome(datainfo).then((response)=>{
            console.log(response)
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功！',
                })
                router.push({ path: '/navtkyl/friendwelcome' })
            }
        })
    }
    
}
//编辑
const checklist = ()=>{
    newwelcomedetail({id:route.query.id}).then((response)=>{
        console.log('编辑')
        console.log(response.data)
        sendtitle.value = response.data.data.title
        sendcon.value =response.data.data.content
        selectedPath.data = []
        // for(var x = 0;x<response.data.data.user_id.split(',').length;x++){
        //     userIds.data.push(response.data.data.user_id.split(',')[x]*1)
        // }

        //将一维数组[{"corp_id"=>1,"id"=>2},{"corp_id"=>3,"id"=>4}]转为二维数组[[1,2],[3,4]]格式
        selectedPath.data = response.data.data.user_id?.map(item => [item.corp_id, item.id]) || []
        console.log('selectedPath.data')
        console.log(response.data.data.user_id)
        console.log(selectedPath.data)

        if(response.data.data.type==1){
            //网页
            checked1.value=true
            weblink.value = response.data.data.web_url
            webcon_emojisOutput.value =  response.data.data.web_title
            webdes_emojisOutput.value = response.data.data.web_des
            web_imgurl.value  = response.data.data.web_image

            temporary.data.jContent.url = weblink.value
            temporary.data.jContent.title = webcon_emojisOutput.value
            temporary.data.desc = webdes_emojisOutput.value
            temporary.data.jContent.desc = webdes_emojisOutput.value
            temporary.data.thumbUrl = web_imgurl.value 
            temporary.data.jContent.thumbUrl = web_imgurl.value 


        }

        if(response.data.data.type==2){
            //图片
            checked2.value=true
            img_imgurl.value = response.data.data.image

            temporary.data.thumbUrl = img_imgurl.value 
            temporary.data.Content = img_imgurl.value 
        }

        // if(response.data.result.content){
            

            // for(var x = 0;x<JSON.parse(response.data.result.content).length;x++){
            //     if(JSON.parse(response.data.result.content)[x].ContentType!='Text'){
            //         temporary.data = JSON.parse(response.data.result.content)[x]
            //     }
            // }

                // if(temporary.data.ContentType == 'Link'){
                //     checked1.value=true
                //     weblink.value = temporary.data.jContent.url
                //     webcon_emojisOutput.value =  temporary.data.jContent.title
                //     webdes_emojisOutput.value = temporary.data.desc
                //     web_imgurl.value  = temporary.data.thumbUrl
                // }else if(temporary.data.ContentType == 'Picture'){
                //     checked2.value=true
                //     img_imgurl.value = temporary.data.thumbUrl
                // }
            
                console.log(temporary.data)
            
            
        // }
        
    })
}
//获取主体+成员下拉
const allcomppeolist = reactive({
    data:[]
})
//获取主体+成员下拉
const getcomppeolist = ()=>{
    newgetcomppeo().then((response)=>{
        if (response.data.msg.code == 0) {
            
            allcomppeolist.data = response.data.data.map(corp => {
                const hasDevices = corp.device && corp.device.length > 0;
                return {
                value: corp.corp_id,
                label: corp.corp_name,
                // 无设备时禁用该项并清空 children
                disabled: !hasDevices,
                children: hasDevices
                    ? corp.device.map(device => ({
                        value: device.id,
                        label: device.name,
                        // 可添加其他自定义属性，如在线状态图标等
                        // 此处保留原始设备对象以便扩展
                        rawDevice: device
                    }))
                    : []
                };
            });
           console.log('主体+成员')
            console.log(allcomppeolist.data)
        }
    })
}
//主体+成员下拉选中的数据
const selectedPath = reactive({
    data:[]
})
//联动数据，过滤数据，只能选一个一级多个二级
const handleChange = (val)=>{
    console.log(val)
    //只能选一个主体
    if(val && val.length > 0){
        // 获取所有一级节点值（父节点ID）
        const parentIds = val.map(item => item[0])
        // 去重获取所有唯一的父节点
        const uniqueParentIds = [...new Set(parentIds)]
        
        // 如果存在多个父节点，只保留最后一个选中的父节点及其子节点
        if(uniqueParentIds.length > 1){
            const lastParentId = uniqueParentIds[uniqueParentIds.length - 1]
            // 筛选出最后一个父节点的所有相关节点
            const newVal = val.filter(item => item[0] === lastParentId)
            // 延迟更新确保界面正确响应
            setTimeout(()=>{
                selectedPath.data = newVal
                console.log(selectedPath.data)
            }, 0)
        }
    }
    
}

</script>

<style scoped>
.t_line{
    width: 100%;
    height: 1px;
    background-color: #DBDBDB;
    margin-top: 30px;
    margin-bottom: 30px;
}
:deep( .el-input__wrapper ){
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_textarea_nobod .el-textarea__inner) {
    
    box-shadow: 0 0 0 0 ;
    resize: none;
    border-bottom: 1px solid #dcdfe6;
}
.t_web_con{
    width: 400px;
    border: 1px solid #4F46E5;
    border-radius: 5px;
  }
  :deep(.t_web_con .el-textarea__inner){
    width: 100%;
    border: none;
    box-shadow: 0 0 0 0px;
    background-color: #F1F3F9;
    resize: none;
  }
  .t_emoji_img{
    width: 20px;
    margin-left: 20px;
    margin-top: 5px;
    cursor: pointer;
  }
  :deep(.t_speak_input .el-textarea__inner){
    width: 100%;
    border: none;
    box-shadow: 0 0 0 0px;
    /* background-color: #F1F3F9; */
    resize: none;
  }
  .avatar-uploader .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  :deep( .avatar-uploader .el-upload) {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

:deep( .avatar-uploader .el-upload:hover) {
  border-color: var(--el-color-primary);
}

:deep(.el-icon.avatar-uploader-icon) {
  font-size: 29px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
.avatar2 {
    width: 178px;
    height: 178px;
    display: block;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
  }
</style>